/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import LastCourseType from './LastCourseType';

/**
 * The StudentLastCourse model module.
 * @module model/StudentLastCourse
 * @version 1.0.0
 */
class StudentLastCourse {
    /**
     * Constructs a new <code>StudentLastCourse</code>.
     * @alias module:model/StudentLastCourse
     * @param id {Number} 
     * @param academicYear {String} 
     */
    constructor(id, academicYear) { 
        
        StudentLastCourse.initialize(this, id, academicYear);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, academicYear) { 
        obj['id'] = id;
        obj['academic_year'] = academicYear;
    }

    /**
     * Constructs a <code>StudentLastCourse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentLastCourse} obj Optional instance to populate.
     * @return {module:model/StudentLastCourse} The populated <code>StudentLastCourse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentLastCourse();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('academic_year')) {
                obj['academic_year'] = ApiClient.convertToType(data['academic_year'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = LastCourseType.constructFromObject(data['type']);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentLastCourse.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
StudentLastCourse.prototype['student_id'] = undefined;

/**
 * @member {String} title
 */
StudentLastCourse.prototype['title'] = undefined;

/**
 * @member {String} academic_year
 */
StudentLastCourse.prototype['academic_year'] = undefined;

/**
 * @member {module:model/LastCourseType} type
 */
StudentLastCourse.prototype['type'] = undefined;






export default StudentLastCourse;

